/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import styled from 'styled-components';
import {
    Icon,
    ICON_SIZES,
    INDENT,
    SplashScreenLayout,
    STACK_ALIGN,
    STACK_DIRECTION,
    STACK_DISTRIBUTION,
    STACK_GAP,
    StackView,
    Text,
} from '@veeam/components';

import type { IconType } from '@veeam/components';

const Title = styled(Text)`
    font-size: 28px;
    line-height: 38px;
    color: ${({ theme }) => theme.colorLoginTitle};
`;

export interface LoginBaseLayoutProps {
    minWidth?: number;
    minHeight?: number;
    productBrandImage?: string;
    productIconLogo?: IconType;
    title?: string;
    children: React.ReactElement;
}

export const LoginBaseLayout: React.FC<LoginBaseLayoutProps> = ({ minWidth, minHeight, productBrandImage, productIconLogo, title, children }) => (
    <SplashScreenLayout
        minWidth={minWidth}
        style={minHeight ? { minHeight } : {}}
        productImageSrc={productBrandImage}
        content={(
            <StackView
                align={STACK_ALIGN.center}
                distribution={STACK_DISTRIBUTION.start}
                direction={STACK_DIRECTION.column}
                gap={STACK_GAP.s}
                size={{ width: '100%' }}
            >
                {(productIconLogo || title) && (
                    <StackView
                        align={STACK_ALIGN.center}
                        direction={STACK_DIRECTION.column}
                        gap={STACK_GAP.s}
                        indentBottom={INDENT.m}
                        size={{ width: '100%' }}
                    >
                        {productIconLogo && <Icon src={productIconLogo} size={ICON_SIZES.xxl} />}
                        {title && <Title truncate>{title}</Title>}
                    </StackView>
                )}

                {children}
            </StackView>
        )}
    />
);
